import type { SvgIconProps } from '@mui/material/SvgIcon'
import type { ComponentType } from 'react'

import AttachMoney from '@mui/icons-material/AttachMoney'
import Computer from '@mui/icons-material/Computer'
import EnergySavingsLeafOutlined from '@mui/icons-material/EnergySavingsLeafOutlined'
import FavoriteBorderOutlined from '@mui/icons-material/FavoriteBorderOutlined'
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined'
import ManageSearchOutlined from '@mui/icons-material/ManageSearchOutlined'
import SchoolOutlined from '@mui/icons-material/SchoolOutlined'
import ShoppingBasketOutlined from '@mui/icons-material/ShoppingBasketOutlined'

/**
 * Curated map of the company-industry `iconName` values seeded by the backend
 * (see mydra-api `add-company-industries` seeder). Keyed by the normalized name
 * (trailing "Icon" stripped) so both `AttachMoney` and `AttachMoneyIcon` resolve.
 *
 * We import only the icons we actually use — never `import * from
 * '@mui/icons-material'`, which would pull the entire icon set into the bundle.
 */
const INDUSTRY_ICONS: Record<string, ComponentType<SvgIconProps>> = {
  Computer,
  AttachMoney,
  SchoolOutlined,
  ShoppingBasketOutlined,
  FavoriteBorderOutlined,
  ManageSearchOutlined,
  EnergySavingsLeafOutlined,
  LocalShippingOutlined,
}

export function getMuiIconByName(
  name: string | undefined
): ComponentType<SvgIconProps> | undefined {
  if (!name?.trim()) return undefined

  // strip trailing "Icon" suffix (e.g. "SchoolOutlinedIcon" → "SchoolOutlined")
  const stripped = name.trim().replace(/Icon$/, '')

  return INDUSTRY_ICONS[stripped]
}
